import { IS_WEB } from "../config";
import { getLogger } from "../logging";

const log = getLogger("fieldsDef");

function toBool(value) {
  return ["true", true].includes(value);
}

function toObj(value) {
  try {
    return JSON.parse(value);
  } catch (err) {
    log.error(`Failed to parse value '${value}' (toObj)`);
  }
  return null;
}

function toDateList(value) {
  try {
    const parsedValue = JSON.parse(value);
    return parsedValue.map((date) => new Date(date));
  } catch (err) {
    log.error(`Failed to parse value '${value}' (toDateList)`);
  }
}

function toSet(value) {
  const obj = toObj(value);
  if (obj === null) return null;
  return new Set(obj);
}

function toString(value) {
  return value;
}

const fieldsDef = {
  translationCache: {
    defaultValue: {},
    parser: toObj,
    noEncrypt: true,
  },
  difficultyFeedbacks: {
    defaultValue: new Set(),
    parser: toSet,
  },
  maxLevelIdx: {
    defaultValue: 0,
    parser: parseInt,
    saveToFirestore: true,
  },
  classicLevelIdx: {
    defaultValue: 0,
    parser: parseInt,
  },
  levelIdx: {
    defaultValue: 0,
    parser: parseInt,
  },
  removedAds: {
    defaultValue: false,
    parser: toBool,
    saveToFirestore: true,
  },
  classicIntroShown: {
    defaultValue: false,
    parser: toBool,
    saveToFirestore: true,
  },
  episodesIntroShown: {
    defaultValue: false,
    parser: toBool,
    saveToFirestore: true,
  },
  disableAutoLevels: {
    defaultValue: false,
    parser: toBool,
  },
  disableMusic: {
    defaultValue: false,
    parser: toBool,
  },
  disableTranslate: {
    defaultValue: false,
    parser: toBool,
  },
  interstitialAdsInterval: {
    defaultValue: 5,
    parser: parseInt,
  },
  animationSpeed: {
    defaultValue: 1,
    parser: parseFloat,
  },
  numLives: {
    defaultValue: 9,
    parser: parseInt,
    saveToFirestore: true,
  },
  numDropBoosters: {
    defaultValue: 3,
    parser: parseInt,
    saveToFirestore: true,
  },
  numCenterBoosters: {
    defaultValue: 2,
    parser: parseInt,
    saveToFirestore: true,
  },
  numShuffleBoosters: {
    defaultValue: 4,
    parser: parseInt,
    saveToFirestore: true,
  },
  numCatchBoosters: {
    defaultValue: 1,
    parser: parseInt,
    saveToFirestore: true,
  },
  numFreezeBoosters: {
    defaultValue: 4,
    parser: parseInt,
    saveToFirestore: true,
  },
  numRandomBoosters: {
    defaultValue: 4,
    parser: parseInt,
    saveToFirestore: true,
  },
  lastLifeLostDate: {
    defaultValue: new Date(),
    parser: (date) => new Date(date),
  },
  screenName: {
    defaultValue: "main_menu",
    parser: toString,
  },
  inviteFriendDeepLink: {
    defaultValue: "",
    parser: toString,
    saveToFirestore: true,
  },
  receivedInviteeBonus: {
    defaultValue: false,
    parser: toBool,
    saveToFirestore: true,
  },
  inviteeIds: {
    defaultValue: [],
    parser: toObj,
    saveToFirestore: true,
    noEncrypt: true,
  },
  fastPlayback: {
    defaultValue: false,
    parser: toBool,
  },
  maxLevelIdxVersionPrev: {
    defaultValue: 0,
    parser: parseInt,
  },
  appVersionPrev: {
    defaultValue: "",
    parser: toString,
  },
  appVersion: {
    defaultValue: "",
    parser: toString,
  },
  gaveFiveStarsReview: {
    defaultValue: false,
    parser: toBool,
  },
  user: {
    defaultValue: {},
    parser: toObj,
    noEncrypt: true,
  },
  profile: {
    defaultValue: {},
    parser: toObj,
    noEncrypt: true,
  },
  communityNavIdx: {
    defaultValue: 1,
    parser: parseInt,
  },
  communityLevelsUser: {
    defaultValue: [],
    parser: toObj,
    noEncrypt: true,
  },
  communityLevelsNew: {
    defaultValue: [],
    parser: toObj,
    noEncrypt: true,
  },
  communityLevelsTrendy: {
    defaultValue: [],
    parser: toObj,
    noEncrypt: true,
  },
  communityLevelsTop: {
    defaultValue: [],
    parser: toObj,
    noEncrypt: true,
  },
  communityLevelsFollowing: {
    defaultValue: {},
    parser: toObj,
    noEncrypt: true,
  },
  communityLevelsFavorites: {
    defaultValue: {},
    parser: toObj,
    noEncrypt: true,
  },
  communityLevelsRatings: {
    defaultValue: {},
    parser: toObj,
    saveToFirestore: true,
    noEncrypt: true,
  },
  levelsFavorited: {
    defaultValue: new Set(),
    parser: toSet,
    saveToFirestore: true,
    firestoreParser: (arr) => new Set(arr),
    noEncrypt: true,
  },
  levelsPlayed: {
    defaultValue: new Set(),
    parser: toSet,
    saveToFirestore: true,
    firestoreParser: (arr) => new Set(arr),
    noEncrypt: true,
  },
  levelsWon: {
    defaultValue: new Set(),
    parser: toSet,
    saveToFirestore: true,
    firestoreParser: (arr) => new Set(arr),
    noEncrypt: true,
  },
  levelEditing: {
    defaultValue: {},
    parser: toObj,
    noEncrypt: true,
  },
  last5PublishedLevel: {
    defaultValue: new Array(5).fill(
      new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
    ),
    parser: toDateList,
    noEncrypt: true,
  },
};

if (IS_WEB) {
  fieldsDef.unsupportedBrowserDialogShown = {
    defaultValue: false,
    parser: toBool,
  };
}

for (let key in fieldsDef) fieldsDef[key].key = key;

if (__DEV__) window.fieldsDef = fieldsDef;

export default Object.freeze(fieldsDef);
